export default "__VITE_ASSET__ac27e59e__"